import _classCallCheck from "/home/jenkins/workspace/tServices_Forms_Client_CICD_main/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/workspace/tServices_Forms_Client_CICD_main/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import { shift as o, flip as n, hide as h, computePosition as c } from "@floating-ui/dom";

var v = /*#__PURE__*/function () {
  function v(e, i) {
    var _this = this;

    _classCallCheck(this, v);

    this.anchor = e, this.floaterId = i, this.anchorElement = void 0, this.floater = void 0, this.callbackFn = void 0, this.positionObserver = void 0, this.sizeObserver = void 0, this.resizeListener = function () {
      return _this.repositionToAnchor();
    };
  }

  _createClass(v, [{
    key: "observe",
    value: function observe(e) {
      this.tryFindElements(), this.callbackFn = e, this.repositionToAnchor(), this.observeAnchor();
    }
  }, {
    key: "unobserve",
    value: function unobserve() {
      [this.positionObserver, this.sizeObserver].forEach(function (e) {
        return e == null ? void 0 : e.disconnect();
      }), window.removeEventListener("resize", this.resizeListener);
    }
  }, {
    key: "tryFindElements",
    value: function tryFindElements() {
      this.tryFindAnchor(), this.floater = document.querySelector("#".concat(this.floaterId)), this.requireAnchor(), this.requireFloating();
    }
  }, {
    key: "tryFindAnchor",
    value: function tryFindAnchor() {
      if (typeof this.anchor == "string") this.anchorElement = document.querySelector("[data-link=\"".concat(this.anchor, "\"]"));else {
        var _this$anchor = this.anchor,
            e = _this$anchor.left,
            i = _this$anchor.top;
        this.anchorElement = {
          getBoundingClientRect: function getBoundingClientRect() {
            return {
              width: 0,
              height: 0,
              x: e,
              y: i,
              left: e,
              right: e,
              top: i,
              bottom: i
            };
          }
        };
      }
    }
  }, {
    key: "requireAnchor",
    value: function requireAnchor() {
      if (!this.anchorElement) throw new Error("Anchor not found");
    }
  }, {
    key: "requireFloating",
    value: function requireFloating() {
      if (!this.floater) throw new Error("Floating element not found");
    }
  }, {
    key: "repositionToAnchor",
    value: function repositionToAnchor() {
      var _this2 = this;

      var e = [o(), n(), h()];
      c(this.anchorElement, this.floater, {
        placement: "bottom",
        middleware: e
      }).then(function (_ref) {
        var i = _ref.x,
            t = _ref.y,
            r = _ref.middlewareData;
        var s = r.hide.referenceHidden;

        _this2.callbackFn({
          top: t,
          left: i,
          visibility: s ? "hidden" : "visible"
        });
      });
    }
  }, {
    key: "observeAnchor",
    value: function observeAnchor() {
      this.initialiseDOMObservers(), window.addEventListener("resize", this.resizeListener), this.anchorElement instanceof Element && (this.positionObserver.observe(this.anchorElement, {
        attributes: !0
      }), this.sizeObserver.observe(this.anchorElement)), this.sizeObserver.observe(this.floater);
    }
  }, {
    key: "initialiseDOMObservers",
    value: function initialiseDOMObservers() {
      var _this3 = this;

      this.positionObserver = new MutationObserver(function () {
        return _this3.repositionToAnchor();
      }), this.sizeObserver = new ResizeObserver(function () {
        return _this3.repositionToAnchor();
      });
    }
  }]);

  return v;
}();

export { v as PositionDetector };